import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, inject } from '@angular/core';
import { StoryblokService } from 'src/app/services/storyblok.service';
import { ProductComparisonListComponent } from '../product-comparison-list/product-comparison-list.component';

@Component({
  selector: 'app-product-comparison-list-item-preview',
  standalone: true,
  templateUrl: './product-comparison-list-item-preview.component.html',
  styleUrls: ['./product-comparison-list-item-preview.component.scss'],
  imports: [CommonModule, ProductComparisonListComponent],
})
export class ProductComparisonListItemPreviewComponent implements OnChanges {
  @Input() _uid: string; // just here to prevent errors
  @Input() component: string; // just here to prevent errors
  @Input() _editable: string;
  @Input() replacer?: (key: string) => string;
  @Input() featureGroups: { title: string; features: unknown[] }[];
  @Input() product: string;

  uuid: string;

  private storyblokService = inject(StoryblokService);

  ngOnChanges(): void {
    const relationships = this.storyblokService.getGlobalData('relationships');
    this.uuid = relationships.find(r => r.content.component === 'ProductComparison').uuid;
  }
}
